import React, { useState } from "react";
import "./ConfirmationDialog.css";

interface ConfirmationDialogProps {
	isOpen: boolean;
	message: string;
	showInput?: boolean;
	onConfirm: (inputValue?: string) => void;
	onCancel: () => void;
}

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	isOpen,
	message,
	showInput = false,
	onConfirm,
	onCancel,
}) => {
	const [inputValue, setInputValue] = useState<string>("");

	if (!isOpen) {
		return null;
	}

	const handleConfirm = () => {
		if (showInput && !inputValue.trim()) {
			return; // Prevent confirming if input is required and empty
		}
		onConfirm(inputValue);
	};

	return (
		<div className="modal-overlay text-black">
			<div className="modal-content">
				<p>{message}</p>
				{showInput && (
					<input
						type="text"
						value={inputValue}
						onChange={(e) => setInputValue(e.target.value)}
						placeholder="Please enter rejection comments:"
					/>
				)}
				<div className="modal-actions">
					<button
						onClick={handleConfirm}
						disabled={showInput && !inputValue.trim()}
						className="btn btn-sm btn-success"
					>
						Yes
					</button>
					<button onClick={onCancel} className="btn btn-sm btn-error">
						No
					</button>
				</div>
			</div>
		</div>
	);
};

export default ConfirmationDialog;
